/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOffers = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m13.414 2 8.964 8.964-10.3 11.443-9.742-8.66L2 13.45V2zM4 12.55l7.92 7.042 7.702-8.556L12.586 4H4z" />
        <path d="M13.658 10.072c-.3-.3-.786-.3-1.086 0l-.543.543 1.085 1.086.544-.544c.3-.3.3-.786 0-1.085zm1.414-1.415a2.768 2.768 0 0 1 0 3.914l-.543.544.919.919-1.415 1.414-.919-.919-1.792 1.793-1.415-1.414 1.793-1.793-1.085-1.086-.543.543a2.768 2.768 0 0 1-3.914-3.914l.543-.543-1.15-1.149 1.415-1.414 1.149 1.15 1.793-1.794 1.414 1.414L9.53 8.115l1.086 1.086.543-.544a2.768 2.768 0 0 1 3.914 0zm-7.5 2.5c.3.3.786.3 1.086 0l.542-.542L8.115 9.53l-.543.542c-.3.3-.3.786 0 1.086z" />
      </g>
    </g>
  </Icon>
);
export { SvgOffers as Offers };
